import { Route } from 'react-router';
import Home from '../components/home/Home';
import Step from '../components/steps/Steps';

export enum RoutePaths {
  HOME = '/',
  STEP = '/:step',
}

export const routes = [
  {
    path: RoutePaths.HOME,
    component: Home,
    exact: true,
  },
  {
    path: RoutePaths.STEP,
    component: Step,
  },
];

function RouteComp(route: any) {
  const { path, ...other } = route;
  return <Route {...other} />;
}

export default RouteComp;
